import React, { Component } from 'react';
import Logo from '../../static/images/logo.png'
import Cookies from 'universal-cookie';
import { connect } from 'react-redux';
import axios from 'axios';

const cookies = new Cookies();

const getState = (state) => {
    return {
        url: state.url
    }
}
const Dispatch = (dispatch) => {
    return {
        Login: (data) => {
            const action = {
                type: 'Login',
                data: data
            }
            dispatch(action)
        }
    }
}

class Login extends Component {
    constructor() {
        super()
        this.state = {
            login: {
                username: '',
                password: ''
            },
            error:false,
            show: false,
        }
    }

    handleChangeField = (e) => {
        let login = this.state.login
        let id = e.target.getAttribute('id')
        login[id] = e.target.value
        this.setState({ login })
    }

    Login = (e) => {
        e.preventDefault();
        this.setState({error:false})
        let url = this.props.url
        let funcion = this.props.Login
        axios.post(url + '/api/v1/core/login/', this.state.login)
            .then(response => {
                cookies.set('csrf', response.data.csrf, { path: '/' });
                cookies.set('token', response.data.token, { path: '/' });
                cookies.set('key', response.data.key, { path: '/' });
                funcion(JSON.stringify(response.data))
            })
            .catch(err => {
                console.log(err)
               this.setState({error:true})
            })
    }

    componentWillMount = () => {
        let token = cookies.get('token')
        let url = this.props.url
        let funcion = this.props.Login
        if (token !== undefined) {
            axios.post(url + '/api/v1/core/validateToken/', { token: token })
                .then(response => {
                    funcion(JSON.stringify(response.data))
                })
                .catch(err => {
                    console.log(err)
                    
                })
        } else {
            this.setState({ show: true })
        }
    }

    render() {
        return (
            <div className="login">
                <div className="login__logo">
                    <img src={Logo} alt="Country Club Logo" />
                </div>
                <div className="row">
                    <div className="offset-md-4 col-sm-12 col-md-4 login__container">
                        <h3 className="text-center">Bienvenid@</h3>
                        <p className="lead-text text-center">Reserva los eventos desde casa accediendo <br/>a nuestra plataforma de reservas.</p>
                        <form className="form text-center">
                            <div className="form__group">
                                <input type="text" className="form__input" onChange={this.handleChangeField} value={this.state.username}  placeholder="Código de Socio" id="username" required/>
                            </div>
                            <div className="form__group">
                                <input type="password" onChange={this.handleChangeField} value={this.state.password} className="form__input" placeholder="Contraseña" id="password" required/>
                            </div>
                            {this.state.error ? 
                            <p className='error-login'>Datos de acceso invalidos.</p>
                            :
                            null
                            }
                            <button onClick={this.Login} className="btn btn-primary">Acceder</button>
                        </form>
                        <div className="login__help text-center">
                            <span className="lead-text">¿No tienes cuenta? <a href="#">Solicitar acceso aquí</a></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(getState, Dispatch)(Login)



// WEBPACK FOOTER //
// ./src/Pages/Login/index.js